import React, { useState } from "react";
import { motion } from "framer-motion";
import emailjs from "@emailjs/browser"; // Import EmailJS
import { FaInstagram, FaTwitter, FaYoutube } from "react-icons/fa"; 




export const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [loading, setLoading] = useState(false); // For loading state
  const [success, setSuccess] = useState(false); // For success message

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    emailjs
      .send(
        "service_w5nvrje", // Replace with your EmailJS Service ID
        "template_jcv749a", // Replace with your EmailJS Template ID
        {
          from_name: formData.name,
          from_email: formData.email,
          message: formData.message,
        },
        "TJW_Yoi-t6igNtEC5" // Replace with your EmailJS Public Key
      )
      .then(
        () => {
          setLoading(false);
          setSuccess(true);
          setFormData({ name: "", email: "", message: "" }); // Reset form
        },
        (error) => {
          console.error("Failed to send email:", error);
          setLoading(false);
        }
      );
  };

  return (
    <div className="bg-black text-white min-h-screen flex flex-col items-center justify-center p-6">
      {/* Contact Header */}
      <motion.div
        className="text-center"
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        <h1 className="text-5xl font-extrabold uppercase tracking-wide text-primary">
          Contact Me
        </h1>
        <p className="text-lg text-gray-300 mt-2">
          Let's get in touch! Fill out the form below.
        </p>
      </motion.div>

      {/* Contact Form */}
      <motion.form
        onSubmit={handleSubmit}
        className="mt-10 bg-gray-900 p-8 rounded-lg shadow-lg w-full max-w-lg"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1, delay: 0.3 }}
      >
        <div className="mb-4">
          <label className="block text-gray-300 text-sm mb-1">Name</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="w-full p-3 rounded bg-gray-800 text-white focus:outline-none"
            required
          />
        </div>

        <div className="mb-4">
          <label className="block text-gray-300 text-sm mb-1">Email</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="w-full p-3 rounded bg-gray-800 text-white focus:outline-none"
            required
          />
        </div>

        <div className="mb-4">
          <label className="block text-gray-300 text-sm mb-1">Message</label>
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            className="w-full p-3 rounded bg-gray-800 text-white focus:outline-none h-32 resize-none"
            required
          />
        </div>

        {/* Success Message */}
        {success && (
          <p className="text-green-500 text-sm mb-3">
            ✅ Message sent successfully!
          </p>
        )}

        <motion.button
          type="submit"
          className={`w-full ${
            loading ? "bg-gray-600 cursor-not-allowed" : "bg-primary hover:bg-red-500"
          } text-white font-semibold px-6 py-3 rounded-lg transition duration-300`}
          whileHover={!loading ? { scale: 1.05 } : {}}
          disabled={loading}
        >
          {loading ? "Sending..." : "Send Message ✉️"}
        </motion.button>
      </motion.form>

      {/* Social Media Links */}
      <motion.div
        className="mt-10 flex gap-6"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 0.5 }}
      >
          <a href="https://instagram.com/chimaudoye?igsh=MTQycTg5dTE1c2I6cw==" target="_blank" rel="noopener noreferrer">
          <FaInstagram className="text-gray-300 hover:text-pink-500 transition duration-300" />
        </a>
        <a href="https://x.com/chima_udoye?t=QC5MxByseIiFY-H6IFsomg&s=o9" target="_blank" rel="noopener noreferrer">
          <FaTwitter className="text-gray-300 hover:text-blue-500 transition duration-300" />
        </a>
        <a href="https://youtu.be/GBIDjR5i5NI?si=sMNP2xR8_R5bz3De" target="_blank" rel="noopener noreferrer">
          <FaYoutube className="text-gray-300 hover:text-red-500 transition duration-300" />
        </a>
      </motion.div>
    </div>
  );
};


